import React, { useState } from 'react';
import 'moment/locale/es';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { Button, Form, FormControl, FormGroup, Icon, IconButton, SelectPicker } from 'rsuite';
import { fetchConToken } from "../../helpers/fetch";
import Swal from 'sweetalert2';
import { startClient } from '../../actions/client';

// import { IconButton, Form, SelectPicker } from 'rsuite';
// import AddOutlineIcon from '@rsuite/icons/AddOutline';

// const data = ['Eugenia', 'Bryan', 'Linda', 'Nancy', 'Lloyd', 'Alice', 'Julia', 'Albert'].map(
//     item => ({ label: item, value: item })
//   );

export const DesgloseExtras = () => {
    const dispatch = useDispatch();
    const {costoPaquete, paquete: {precio_cuadruple, precio_doble, precio_triple, extras}, habitacion = {tipo: '4'}, recargo} = useSelector(state => state.client); 
    const [extrasSelect, setExtrasSelect] = useState({
        loading: true,
        data: []
    });
    const [selectExtra, setSelectExtra] = useState(null)

    const handleUpdateExtrasSelect = async () => {
        setExtrasSelect( e => ({
            ...e,
            loading: true,
        }))
        if (extrasSelect.data.length === 0) {
            await consultaextras();
          }
          setExtrasSelect( e => ({
            ...e,
            loading: false,
        }))
    }

    const consultaextras = async() => {
        const resp = await fetchConToken('extras');
        const body = await resp.json();
        setExtrasSelect( e => ({
            ...e,
            data: body.data,
        }))
    }

    const handleSubmit =(e) => {
        // e.preventDefault();
        Swal.fire({
            title: 'Importante',
            text: `Estás a punto de agregar un extra a tu viaje.
            Si decides continuar estas aceptando que el costo de tu paquete sea modificado sin posibilidad a ser eliminado posteriormente. 
            La fecha y políticas de liquidación permanecen sin cambio y se aplican al costo total de tu paquete.`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar'
            }).then( async(result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    // title: 'Importante',
                    text: `¿Estás seguro de realizar esta modificación en tu paquete?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, Agregar!',
                    cancelButtonText: 'Cancelar'
                    }).then( async(result) => {
                    if (result.isConfirmed) {
                        const resp = await fetchConToken(`extras/${selectExtra}`);
                        const body = await resp.json();
                        if(body.ok){
                            setSelectExtra(null);
                            consultaextras();
                            dispatch( startClient() );
                        }
                        Swal.fire(
                        'Felicidades!',
                        `Tu extra fue agregado.
                        Puedes verificar tus complementos en el apartado "desglose de costos"`,
                        'success'
                        )
                    }
                })
            }
        })
    }
        return (
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Desglose de costos</h5>
                    {/* <p>
                        El siguiente desglose es una guía para mejorar el control de tus pagos que toma en cuenta el costo total de tu viaje dividido entre los meses que faltan para ser liquidado.<br />
                        Puedes adelantar tus pagos y se asignarán a los meses correspondientes. En caso de no cubrir el monto total de tu mensualidad, en la última columna podrás ver la cantidad faltante para completar ese pago.
                    </p> */}
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr className="text-center">
                                    <th scope="col">Concepto</th>
                                    <th scope="col">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center text-nowrap d-flex justify-content-center align-content-center">
                                    <span className="material-icons text-success" style={{fontSize: '1.5em'}}>luggage</span>
                                        Tarifa base
                                    </td>
                                    <td className="text-center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(precio_cuadruple)}</td>
                                </tr>

                               { recargo === '1' &&

                                    <tr className='text-danger'>
                                        <td className="text-center text-nowrap d-flex justify-content-center align-content-center">
                                            Regargos
                                        </td>
                                        <td className="text-center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(costoPaquete/1.1*.1    )}</td>
                                    </tr>

                               }

                                <tr>
                                    <td className="text-center text-nowrap d-flex justify-content-center align-content-center">
                                        Habitacion {habitacion.tipo === '2' ? 'Doble' : habitacion.tipo === '3' ? 'Triple' : habitacion.tipo === '4' ? 'Cuadruple' : 'Quintuple'}
                                    </td>
                                    <td className="text-center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(habitacion.tipo === '2' ? precio_doble : habitacion.tipo === '3' ? precio_triple : 0)}</td>
                                </tr>
                                {
                                    extras.map(extra => (
                                        <tr key={ extra.noMes }>
                                            <td className="text-center text-nowrap d-flex justify-content-center align-content-center">
                                                {extra.name}
                                            </td>
                                            <td className="text-center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(extra.cost)}</td>
                                        </tr>
                                    ))
                                }

                                
                                {/* <tr>
                                    <td className="">
                                        <SelectPicker data={extrasSelect.data} block />
                                    </td>
                                    <td className="text-center"><IconButton color='blue' icon={<Icon icon="plus" />} >Agregar</IconButton></td>
                                </tr> */}


                            </tbody>
                            <tfoot>
                                <tr>
                                    <th className="text-right">Total:</th>
                                    <th className="text-center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(costoPaquete)}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div>
                        <p>*Agrega extras a tu paquete.</p>
                        <Form fluid onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="text-center col-12 col-md-9" style={{borderTop: 'none'}}>
                                    <SelectPicker
                                        data={extrasSelect.data}
                                        value={selectExtra}
                                        onChange={setSelectExtra}
                                        placeholder={(<>Seleccionar</>)}
                                        searchable={false}
                                        block
                                        onOpen={handleUpdateExtrasSelect}
                                        required
                                        renderValue={(value, item, selectedElement) => {
                                            return (
                                                <div className="row mr-1 ml-1">
                                                    <div className="col-8">{selectedElement}</div>
                                                    {/* <div className={`col-4 ${item.cost <= 0 ? 'text-danger': 'text-success'}`} ><strong>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(item.cost)}</strong></div> */}
                                                </div>
                                            )
                                        }}
                                        renderMenuItem={(label, item) => {
                                            return (
                                                <div className="row mr-1 ml-1">
                                                    <div className="col-8">{label}</div>
                                                    <div className={`col-4 ${item.cost <= 0 ? 'text-danger': 'text-success'}`} ><strong>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(item.cost)}</strong></div>
                                                </div>
                                            );
                                            }}
                                        renderMenu={menu => {
                                        if (extrasSelect.loading) {
                                            return (
                                            <p style={{ padding: 4, color: '#999', textAlign: 'center' }}>
                                                <Icon icon="spinner" spin /> Cargando...
                                            </p>
                                            );
                                        }
                                        return menu;
                                        }}
                                    />
                                </div>
                                <div className="text-center col-md-3 col-12 "><IconButton color='blue' icon={<Icon icon="plus" />} type="submit" disabled={selectExtra == null}>Agregar</IconButton></div> 
                            </div>
                        </Form>
                    </div>     
                </div>
            </div>
        )
}
